<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{ tituloGrids }}</span>
      </v-col>
      <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs class="py-2 px-0" :items="aItemsBreadcrumbs" divider=">">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item class="titlesdark--text">
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <grid
          v-if="this.$store.state.token != ''"
          :tabla="TablaName"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="true"
          :sIdTable="'id_Pregunta'"
          :bShowMapDetails="false"
          :bActiveNew="true"
          :aInfoTBDetalleExp="aDetallesExport"
          @idSelect="getIdSelect"
          @nameField="getNameFieldSelect"
          @oItemSeleccionado="getItemSeleccionado"
        >
        </grid>
      </v-col>
      <v-col md="12" sm="12" cols="12" class="pa-0 ma-0 mt-2">
        <grid-detalle
          v-if="parseInt(nIdSeleccionado) > 0"
          :tabla="'COPSECANCOL_Preguntas_Convertir_Pqr'"
          :sIdTable="'idCOPSECANCOL_Preguntas_Convertir_Pqr'"
          :bActiveFilter="false"
          :bActiveExport="false"
          :bSingleSelect="false"
          :bShowSelect="false"
          :bShowMapDetails="false"
          :bActiveSearch="false"
          :bActiveNew="true"
          :bGridDetalle="true"
          :nIdValor="parseInt(nIdSeleccionado)"
          :sCampoFiltro="'id_Pregunta'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import grid from "@/components/Grid/Grid.vue";
import mxFunciones from "@/mixins/funciones.js";
import GridDetalle from "@/components/Grid/Grid.vue";
// import DialogFirmas from '@/components/DialogFirmas.vue'

export default {
  name: "CopPreguntas",
  components: {
    grid,
    GridDetalle,
    // DialogFirmas
  },
  mixins: [mxFunciones],
  data() {
    return {
      TablaName: "COPSECANCOL_Preguntas", // Nombre de la tabla a trabajar
      nIdSeleccionado: 0, // Id seleccionado
      sNombreCampoFiltro: "", // Nombre del campo foreignKey
      oItemSeleccionado: {},
      nKeyReset: 0,
      aItemsBreadcrumbs: [
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlInicio,
          disabled: true,
          href: "/Dashboard",
        },
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlModuloOperaciones,
          disabled: true,
          href: "/Inicio/Operaciones",
        },
        {
          text: "",
          disabled: true,
          href: "breadcrumbs_dashboard",
        },
      ],
      aDetallesExport: [
        {
          sTablaDetalle: "COPSECANCOL_Preguntas_Convertir_Pqr",
          sNombreCampoFiltroDetalle: "id_Pregunta",
          sCampoParaFiltroTBPrincipal: "id_Pregunta",
        },
      ],
    };
  },
  async mounted() {
    this.onValidarTokenSinLogin();
    this.tituloGrids = await this.getTitulo(this.TablaName);
    this.aItemsBreadcrumbs[2].text = this.tituloGrids;
  },
  methods: {
    getIdSelect(sIdSelected) {
      this.nIdSeleccionado = sIdSelected;
    },
    getNameFieldSelect(sNameFiled) {
      this.sNombreCampoFiltro = sNameFiled;
    },
    getItemSeleccionado(oItemSeleccionado) {
      this.oItemSeleccionado = oItemSeleccionado;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>